export default __webpack_public_path__ + "static/linkBg6_shadow-9ee4dc8b8f75bfdf432d73649cd31446.png";